import { render } from "./SplitButton.vue?vue&type=template&id=7617c6cb&scoped=true&ts=true"
import script from "./SplitButton.vue?vue&type=script&lang=ts"
export * from "./SplitButton.vue?vue&type=script&lang=ts"

import "./SplitButton.vue?vue&type=style&index=0&id=7617c6cb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7617c6cb"]])

export default __exports__